import styles from './ContactSection.module.scss';
import React from "react";
import {Col, Image, Row} from "react-bootstrap";
import vkLogo from './VK Logo.png';
import SectionTagCopy from "../../../../components/SectionTagCopy/SectionTagCopy";

const ContactSection = () => {
    const contacts = [
        {
            id: 1,
            name: "ЗООМИР Верещагино",
            link: "https://vk.com/zoomirver",
            address: "г. Верещагино, ул. Советская, 63",
            phone: ""
        },
        {
            id: 2,
            name: "ЗООДОКТОР Верещагино",
            link: "https://vk.com/zoodokver",
            address: "г. Верещагино, ул. К. Маркса, 64",
            phone: "+7 (902) 477 72 52"
        },
        {
            id: 3,
            name: "ЗООМИР Карагай",
            link: "https://vk.com/umka.karagai",
            address: "с. Карагай, ул. Кирова, 19",
            phone: ""
        }
    ];

    const handleClick = (url: any) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <section id="social-chanels" className={styles.section}>
            <div className={styles.inSection}>
                <SectionTagCopy anchorId="social-chanels" label=""/>
                <h1 className={styles.title}>
                    Наши соцсети
                </h1>
                <p className={styles.subtitle}>
                    Подписывайтесь на наши группы ВКонтакте
                </p>

                <Row className={`${styles.contactsRow} m-0`}>
                    {contacts.map((contact) => (
                        <Col key={contact.id} xs={12} md={4} className={styles.contactCol}>
                            <div
                                className={styles.contactCard}
                                onClick={() => handleClick(contact.link)}
                                role="button"
                                tabIndex={0}
                                onKeyPress={(e) => e.key === 'Enter' && handleClick(contact.link)}
                            >
                                <div className={styles.vkLogoWrapper}>
                                    <Image
                                        src={vkLogo}
                                        alt="VK"
                                        className={styles.vkLogo}
                                    />
                                </div>

                                <h3 className={styles.contactName}>
                                    {contact.name}
                                </h3>

                                <div className={styles.contactInfo}>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoIcon}>📍</span>
                                        <span className={styles.infoText}>{contact.address}</span>
                                    </div>
                                    {contact.phone !== "" &&
                                        <div className={styles.infoItem}>
                                            <span className={styles.infoIcon}>📞</span>
                                            <span className={styles.infoText}>{contact.phone}</span>
                                        </div>
                                    }

                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>

            </div>

        </section>
    );
};

export default ContactSection;
